import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../utils/api';
import './Login.css';

export default function ChangePassword() {
  const { user, token, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [nw, setNw] = useState('');
  const [conf, setConf] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (nw !== conf) { setError('Las contraseñas no coinciden'); return; }
    if (nw.length < 8) { setError('Mínimo 8 caracteres'); return; }
    setError(''); setLoading(true);
    try {
      await api.setFirstPassword(token, nw);
      await refreshUser();
      const role = user?.role;
      navigate(role === 'admin' ? '/admin' : role === 'moderator' ? '/moderador' : '/eventos');
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-bg-runes">ᚠᚢᚦᚨᚱᚲᚷᚹᚺᚾᛁᛃᛇᛈᛉᛊᛏᛒᛖᛗᛚᛜᛞᛟ</div>
      <div className="login-card">
        <div className="login-brand">
          <div className="login-rune">ᚠ</div>
          <h1 className="login-title">Aldealix</h1>
          <p className="login-sub">Establece tu contraseña</p>
        </div>
        <div className="login-divider" />
        <div className="alert alert-info" style={{ marginBottom: '1.2rem' }}>
          <span>🔑</span> Es tu primer acceso. Por favor, elige una contraseña personal.
        </div>
        {error && <div className="alert alert-error" style={{ marginBottom: '1rem' }}><span>⚠</span> {error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Nueva contraseña</label>
            <input className="form-input" type="password" value={nw} onChange={e => setNw(e.target.value)} placeholder="Mínimo 8 caracteres" required autoFocus />
          </div>
          <div className="form-group">
            <label className="form-label">Confirmar contraseña</label>
            <input className="form-input" type="password" value={conf} onChange={e => setConf(e.target.value)} placeholder="Repite la contraseña" required />
          </div>
          <button type="submit" className="btn btn-primary btn-full btn-lg" style={{ marginTop: '.5rem' }} disabled={loading}>
            {loading ? <><span className="spinner" /> Guardando...</> : 'Establecer contraseña'}
          </button>
        </form>
      </div>
    </div>
  );
}
